import { observer } from 'mobx-react-lite';
import { TextInput, View, ViewStyle } from 'react-native';
import { useStore } from 'src/contexts/StoreContext';
import { style } from './BottomSheetSaveProject.style';
import { getTimeAndDateInfo } from 'src/helpers/time.helper';
import { SAVING_STATE } from 'src/store/page-project/pageProject.constants';
import TextLato from '../text/text-lato/TextLato';
import { brand, neutrals } from 'src/theme/colors';
import { useState } from 'react';
import { useDebounceCallback } from 'src/hooks/useDebounceCallback';
import { ICON_NAMES } from '../icon/icon.helper';
import { TestIDs } from 'src/constants/testIDs.constants';
import { bottomSheetTestID } from 'src/helpers/testIDs.helper';
import { CircularButton } from '../buttons/circular-button/CircularButton';
import { CIRCULAR_BUTTON_SIZES, CIRCULAR_BUTTON_TYPES } from '../buttons/circular-button/CircularButton.constants';
import { FocusGroups } from '../focus-provider/FocusProvider.constants';
import { BottomSheetScrollView } from '@gorhom/bottom-sheet';
const TITLE_MAX_LENGHT = 32;
export const BottomSheetSaveProject = observer(({ bsStyle }: { bsStyle: ViewStyle }) => {
  const {
    i18n,
    project: { activeProject },
    bottomSheet: { closeBottomSheet },
  } = useStore();
  const [projectTitle, setProjectTitle] = useState<string>(activeProject?.name ?? '');
  const [isInputFocused, setIsInputFocused] = useState<boolean>(false);

  const setProjectName = useDebounceCallback((text: string) => {
    activeProject?.setName(text);
  }, 1000);

  const handleNewTitle = (text: string) => {
    if (text.length <= TITLE_MAX_LENGHT) {
      setProjectTitle(text);
      setProjectName(text);
    }
  };
  const timeAndDateInfo = getTimeAndDateInfo(activeProject!.lastSaveTimestamp);

  return (
    <BottomSheetScrollView contentContainerStyle={bsStyle}>
      <View style={style.iconClose}>
        <CircularButton
          onPress={async () => closeBottomSheet()}
          accessible={true}
          accessibilityLabel={i18n.t('actions:close_x', { x: '' })}
          accessibilityRole="button"
          iconName={ICON_NAMES.Close}
          iconStyle={{ color: neutrals.neutralGrays.ash }}
          size={CIRCULAR_BUTTON_SIZES.SMALL}
          type={CIRCULAR_BUTTON_TYPES.ONLY_ICON}
          testID={bottomSheetTestID(TestIDs.CLOSE)}
          focusId={bottomSheetTestID(TestIDs.CLOSE)}
          focusOrder={0}
          focusGroup={FocusGroups.BOTTOM_SHEET}
        />
      </View>

      <View style={style.container}>
        {activeProject?.savingState === SAVING_STATE.saved && (
          <View style={style.topContent}>
            <TextLato style={style.title}>{i18n.t('tooltip-save-project:auto-saved')}</TextLato>
            {timeAndDateInfo && (
              <TextLato style={style.description}>
                {i18n.t('tooltip-save-project:last-save_date_hour', timeAndDateInfo)}
              </TextLato>
            )}
          </View>
        )}
        {activeProject?.savingState === SAVING_STATE.saving && (
          <View style={[style.topContent, { gap: 16 }]}>
            <TextLato style={style.title}>{i18n.t('tooltip-save-project:saving')}</TextLato>
            {/* PROGRESS BAR NOT PRESENT IN FIRST RELEASE */}
            {/* <View style={style.progressBar}>
              <View style={[style.progressBarContent, { width: '60%' }]}>
                <LinearGradient
                  colors={[brand.main.iris, brand.main.hibiscus, brand.main.orange]}
                  start={{ x: 0, y: 0 }}
                  end={{ x: 1, y: 0 }}
                  style={style.progressBarGradient}
                >
                  <TextLato style={style.progressBarText}>60%</TextLato>
                </LinearGradient>
              </View>
            </View> */}
          </View>
        )}
        <View style={style.bottomContent}>
          <TextLato style={style.subtitle}>{i18n.t('tooltip-save-project:title')}</TextLato>
          <View style={[style.input, isInputFocused && style.inputFocus]}>
            <TextInput
              style={style.inputText}
              onChangeText={text => handleNewTitle(text)}
              value={projectTitle}
              placeholder="Progetto 1"
              placeholderTextColor={neutrals.neutralGrays.grey}
              onFocus={() => setIsInputFocused(true)}
              onBlur={() => setIsInputFocused(false)}
            />
            <TextLato style={style.inputCounter}>
              {projectTitle.length}/{TITLE_MAX_LENGHT}
            </TextLato>
          </View>
        </View>
      </View>
    </BottomSheetScrollView>
  );
});
